import { Module, Mutation, Action, VuexModule } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/services/ApiService";
import HomePageLayoutData from "@/models/moduleArea/HomePageLayoutData";

import i18n from "@/i18n";

export const BASE_ENDPOINT = "api/v1/LandingPageLayout";

@Module({ name: "homeConfigurationData" })
export default class HomeConfigurationDataModule extends VuexModule {
  configurationData: HomePageLayoutData = new HomePageLayoutData();
  rightLogo = "";
  leftLogo = "";

  get configuration(): HomePageLayoutData {
    return this.configurationData;
  }

  get leftLogoUrl(): string {
    return this.leftLogo;
  }

  get rightLogoUrl(): string {
    return this.rightLogo;
  }

  @Mutation
  [Mutations.GET_MODULE_DATA](moduleData: HomePageLayoutData): void {
    this.configurationData = moduleData;
  }

  @Mutation
  [Mutations.SET_RIGHT_LOGO](rightLogo: string): void {
    this.rightLogo = rightLogo;
  }

  @Mutation
  [Mutations.SET_LEFT_LOGO](leftLogo: string): void {
    this.leftLogo = leftLogo;
  }

  @Action({ rawError: true })
  getModuleDataAction(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      ApiService.get(`${BASE_ENDPOINT}/GetModuleAreaLayout`)
        .then(({ data }) => {
          this.context.commit(Mutations.GET_MODULE_DATA, data);
          this.context.commit(Mutations.SET_LEFT_LOGO, data.leftLogo);
          this.context.commit(Mutations.SET_RIGHT_LOGO, data.rightLogo);
          resolve();
        })
        .catch((error) => {
          const errorMessage = i18n.t(
            "alerts.homeConfigurationDataModule.errorRetrievingModuleAreaLayout"
          );
          this.context.commit(Mutations.SHOW_USER_FEEDBACK, {
            timeout: 5000,
            color: "error",
            message: `${errorMessage} <br/>"${error.message}"`,
          });
          console.log(`${errorMessage} ${error}`);
          reject(error);
        });
    });
  }

  @Action
  updateModuleDataAction(moduleData: HomePageLayoutData): Promise<void> {
    return new Promise<void>((resolve) => {
      ApiService.post(`${BASE_ENDPOINT}/UpdateModuleAreaLayout`, moduleData)
        .then(() => {
          this.context.commit(Mutations.GET_MODULE_DATA, moduleData);

          const successMessage = i18n.t(
            "alerts.homeConfigurationDataModule.successMessageUpdatingModuleAreaLayout"
          );
          this.context.commit(Mutations.SHOW_USER_FEEDBACK, {
            timeout: 5000,
            color: "success",
            message: successMessage,
          });
          resolve();
        })
        .catch((error) => {
          const errorMessage = i18n.t(
            "alerts.homeConfigurationDataModule.errorUpdatingModuleAreaLayout"
          );
          this.context.commit(Mutations.SHOW_USER_FEEDBACK, {
            timeout: 5000,
            color: "error",
            message: `${errorMessage} <br/>"${error.message}"`,
          });
          console.log(`${errorMessage} ${error}`);
        });
    });
  }
}
